import Step from "../../components/step/Step";
import { Box, SimpleGrid, Text, useRadioGroup } from "@chakra-ui/react";
import RadioCard from "../../components/radio-card/RadioCard";
import { useNavigate } from "react-router-dom";
import useStore from "../../storage/DataStore";
import maleBody1 from "../../assets/step3/dreambody-male-1.png";
import maleBody2 from "../../assets/step3/dreambody-male-2.png";
import maleBody3 from "../../assets/step3/dreambody-male-3.png";
import femaleBody1 from "../../assets/step3/dreambody-female-1.png";
import femaleBody2 from "../../assets/step3/dreambody-female-2.png";
import femaleBody3 from "../../assets/step3/dreambody-female-3.png";
import { translation } from "../../utils/translation";

function Step4() {
  let navigate = useNavigate();

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "q4",
    onChange: () => {
      navigate("../step6", { replace: true });
    },
  });

  const state = useStore.getState();

  const options = [
    {
      id: "a1",
      icon: state.gender === "male" ? maleBody1 : femaleBody1,
      text: translation("general.step4.option1"),
    },
    {
      id: "a2",
      icon: state.gender === "male" ? maleBody2 : femaleBody2,
      text: translation("general.step4.option2"),
    },
    {
      id: "a3",
      icon: state.gender === "male" ? maleBody3 : femaleBody3,
      text: translation("general.step4.option3"),
    },
  ];

  const group = getRootProps();

  return (
    <Step
      heading={translation("general.step4.headline")}
      currentStep={3}
      backLink={"/step2"}
    >
      <SimpleGrid mt={5} spacing={2} columns={1} {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value: value.id });
          return (
            <RadioCard key={value.id} {...radio}>
              <Box display={"flex"} alignItems={"center"}>
                <Box mr={5}>
                  <img height={100} width={100} src={value.icon} alt="" />
                </Box>
                <Text fontSize={"lg"} fontWeight={"bold"} mt={3}>
                  {value.text}
                </Text>
              </Box>
            </RadioCard>
          );
        })}
      </SimpleGrid>
    </Step>
  );
}

export default Step4;
